import React from "react";
import { Card, Table, Typography, Tag } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const { Title, Text } = Typography;

const OrderReport = ({ orderData }) => {
  // Transform data for Recharts
  const chartData =
    orderData?.ordersByStatus?.map((status) => ({
      status: status._id,
      Amount: status.totalAmount,
    })) || [];

  // Define colors for different order statuses
  const getBarColor = (status) => {
    const colors = {
      Completed: "#52c41a",
      Pending: "#faad14",
      Cancelled: "#f5222d",
      Unfulfilled: "#1890ff",
    };
    return colors[status] || "#8884d8";
  };

  const columns = [
    {
      title: "Status",
      dataIndex: "_id",
      key: "status",
      render: (status) => {
        const colors = {
          Completed: "green",
          Pending: "orange",
          Cancelled: "red",
          Unfulfilled: "blue",
        };
        return <Tag color={colors[status] || "default"}>{status}</Tag>;
      },
    },
    {
      title: "Orders",
      dataIndex: "count",
      key: "count",
      sorter: (a, b) => a.count - b.count,
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "amount",
      render: (amount) => `$${amount.toFixed(2)}`,
      sorter: (a, b) => a.totalAmount - b.totalAmount,
    },
  ];

  return (
    <div className="space-y-4">
      <Card title="Orders by Status">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={chartData}
            layout="vertical"
            margin={{ top: 5, right: 30, left: 60, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis dataKey="status" type="category" />
            <Tooltip formatter={(value) => `$${value.toFixed(2)}`} />
            <Legend />
            <Bar
              dataKey="Amount"
              fill="#8884d8"
              name="Total Amount"
              // Custom bar color based on status
              shape={(props) => {
                const color = getBarColor(props.payload.status);
                return <rect {...props} fill={color} />;
              }}
            />
          </BarChart>
        </ResponsiveContainer>
      </Card>

      <Card title="Order Status Breakdown">
        <Table
          columns={columns}
          dataSource={orderData?.ordersByStatus || []}
          rowKey="_id"
          pagination={false}
        />
      </Card>
    </div>
  );
};

export default OrderReport;
